import React from "react";
import MainPage from "./MainPage";
import { useParams } from "react-router-dom";
import data from "../../../components/data";
import ProjectTools from "../../../components/ProjectTools";

export default props => {
  let { id } = useParams();
  let { name, image, description, gitHub, fullDescription,live, techStack } = data.projects[id];
  return (
    <div id="page-wrapper">
      <MainPage
          name={name}
          image={image}
          description={description}
          fullDescription={fullDescription}
          projectLink={live}
          techStack={techStack}
        >
        <ProjectTools gitHub={gitHub}/>
      </MainPage>
    </div>
  );
};
